/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


angular
    .module('menuAllSites')
    .controller('menuCtrl', menuCtrl);
menuCtrl.$inject = ['$q', '$scope', '$timeout','getAllSites'];


///// FUNCTIONS /////

function menuCtrl($q, $scope, $timeout,getAllSites){
    void 0;
    void 0;
    $scope.getClass = getClass;
    $scope.getSizeofTheWall = getSizeofTheWall;
    
    getAllSites.async().then(function(resp){
        void 0;
        $scope.sites = resp;
        $scope.getSizeofTheWall(resp);
    });

    function getSizeofTheWall(resp){
        var w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            screenWidth = w.innerWidth || e.clientWidth || g.clientWidth,
            // y = w.innerHeight|| e.clientHeight|| g.clientHeight,
            itemsInRow,
            widthContainer;

        if(screenWidth > 959){
            itemsInRow = 4;
            widthContainer = 960;
        } else if (screenWidth > 599){
            itemsInRow = 3;
            widthContainer = screenWidth;
        } else {
            itemsInRow = 2;
            widthContainer = screenWidth;
        }

        $scope.variableHeight = Math.ceil(resp.length/ itemsInRow);
        $scope.imgWidth = widthContainer / itemsInRow - (25*(widthContainer / itemsInRow) / 100 );
    }

    function getClass(background){
        var newClass;
        if (!background){
            newClass = 'no-background';
        } else {
            newClass = 'ok-background';
        }
        return newClass;
    }
}